import { render, staticRenderFns } from "./PricePartForm.vue?vue&type=template&id=078ac46a"
import script from "./PricePartForm.vue?vue&type=script&lang=ts"
export * from "./PricePartForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports